module.exports = __webpack_public_path__ + "img/pi-3-2.3fe332e1.jpg";